/* eslint-disable max-len */

import type { ApiLangPack } from '../api/types';

export const fallbackLangPackInitial = {
  HideInProtectedGroup: 'Private chat is disabled in this group',
  PrivateChatDaMei: 'Disable private chat',
  ProtectedHiddenParticipants: 'Members are hidden. Cannot enable private chat restriction.',
  ErrorUnauthorized: 'You are not authorized to perform this action',
  'startChat': 'Start Chat',
  'sendComment': 'Send a friend request',
  'sendRemarkName': 'Set Remark Name',
  'userinfo': 'User Info',
  'deleteApplication': 'Delete Application', 
  'waiting': 'Waiting',
  'accepted': 'Accepted',
  'rejected': 'Rejected',
  'reject': 'Reject',
  'agree': 'Agree', 
  'NewApplication': 'Application',
  'placeholders.ContactList': 'No contacts matched your search.',
  'placeholders.ContactListEmpty': 'Contact list is empty.',  
  'placeholders.ApplicationList': 'No applications matched your search.',
  'placeholders.ApplicationListEmpty': 'Application list is empty.',
  ApplicationList: 'Application List',
  MenuAddAccount: 'Add Account',
  PremiumLimitAccountsTitle: 'Limit Reached',
  PremiumLimitAccountsNoPremium: 'You have reached your current limit of connected accounts. You can free one more place by subscribing to 68IM Premium.',
  PremiumLimitAccountsPremium: 'You have reached your current limit of connected accounts.',
  'Contacts.Username.NotRegistred': 'Username not found',
  WrongNumber: 'Wrong number?',
  SentAppCode: `We\'ve sent the code to the **68IM** app on your other device.`,
  'Login.JustSentSms': 'We have sent you a code via SMS. Please enter it above.',
  'Login.JustSentEmail': 'We have sent you a code via email. Please enter it above.',
  'Login.PasswordResetSentSms': 'We have sent a verification code to your phone number. Please enter it below.',
  'Login.PasswordResetSentEmail': 'We have sent a verification code to your email. Please enter it below.',
  'Login.Header.Password': 'Enter Password',
  'Login.EnterPasswordDescription': 'You have Two-Step Verification enabled, so your account is protected with an additional password.',
  CheckPasswordPlaceholder: 'Password',
  Next: 'Next',
  Continue: 'Continue',
  StartText: 'Please confirm your country code and enter your phone number.',
  'Login.PhonePlaceholder': 'Your phone number',
  'Login.Next': 'Next',
  'Login.QR.Login': 'Log in by QR Code',
  'Login.QR.Title': `Log in to 68IM by QR Code`,
  'Login.QR.Help1': `Open 68IM on your phone`,
  'Login.QR.Help2': 'Go to **Settings** > **Devices** > **Link Desktop Device**',
  'Login.QR2.Help2': 'Go to **Settings** → **Devices** → **Link Desktop Device**',
  'Login.QR.Help3': 'Point your phone at this screen to confirm login',
  'Login.QR.Cancel': 'Log in by phone Number',
  'Login.QR.EmailLogin': 'Log in by Email',
  YourName: 'Your Name',
  'Login.Register.Desc': 'Enter your name and add a profile picture.',
  'Login.Register.FirstName.Placeholder': 'First Name',
  'Login.Register.LastName.Placeholder': 'Last Name',
  'Login.Register.Invite.Placeholder': 'Invite Code',
  Required: 'Required',
  UnRequired: 'UnRequired', 
  'Login.SelectCountry.Title': 'Country',
  lng_country_none: 'Country not found',
  LoginPass: 'Login Password',
  LoginPassTip: 'Password must be 8-16 characters. All letters are allowed, but all numbers are not',
  LoginPassInput: 'Please enter your login password',
  LoginInputOldPass: 'Please enter your old login password',
  LoginOldPassError: 'Old login password is incorrect',
  LoginPassPhone: 'Verify by phone',
  LoginPassEmail: 'Verify by email',
  LoginPassNotSet: 'Not Set',
  LoginPassAlreadySet: 'Already Set',
  LoginPassNoIdentifier: 'This account has no phone number or email available for verification',
  LoginSetPass: 'Set Login Password',
  LoginSetNewPass: 'Set New Login Password',
  LoginForgotPassword: 'Forgot password?',
  LoginAccountPassTip: 'For your account security, please set a login password',
  PleaseEnterNewFirstPasswordHint: 'Enter a new password',
  PleaseEnterNewSecondPasswordHint: 'Re-enter the new password',
  PleaseEnterPassword: 'Enter your new password',
  PHONE_NUMBER_INVALID: 'Invalid phone number',
  PHONE_CODE_INVALID: 'Invalid code',
  PASSWORD_HASH_INVALID: 'Incorrect password',
  USER_PASSWORD_INVALID: 'Incorrect password',
  USER_PASSWORD_ERROR: 'Incorrect password',
  USER_PASSWORD_INVALI: 'Invalid password',
  PHONE_PASSWORD_FLOOD: 'For your account security, this device cannot change the login password yet. Please try again later.',
  PHONE_NUMBER_BANNED: 'This phone number is banned.',
  BAD_REQUEST: 'Registration failed. Please check your name or invite code and try again.',
  INVITE_CODE_REQUIRED: 'Please enter an invite code',
  INVITE_CODE_INVALID: 'Invalid invite code',
  FIRSTNAME_INVALID: 'Invalid name',
  PHONE_CODE_EXPIRED: 'Verification code expired. Please request a new one',
  VALIDATE: 'Human verification failed. Please try again.',
  SENDCODE_OVERRUN: 'Too many attempts. Please try again later.',
  SEND_CODE_UNAVAILABLE: 'Unable to send the code. Please try again later.',
  SMS_ERROR_TO_EMAIL: 'SMS could not be sent. Please sign in with email instead.',
  MERCHANT_BANNED: 'This service has been suspended.',
  MERCHANT_DELETED: 'This service is no longer available.',
  ALREADY_REGISTERED: 'This number is already registered.',
  DELETE_USER_TO_SHORT: 'An account deleted with this number can be re-registered only after 30 days.',
  USER_DEACTIVATED: 'This account has been deactivated.',
  IP_BANNED: 'Your IP address has been banned.',
  DEVICE_BANNED: 'This device has been banned.',
  AuthRequestFailed: 'Request failed. Please try again later.',
} as ApiLangPack;
